import { useSelector, useDispatch } from "react-redux";
import { setUserData as setUserDataAction } from "../store/slices/userData.slice.js";
import { useNavigate } from "react-router-dom";

// utils
import API from '../utils/api.js';

// constants
import ROUTES from '../constants/routes.js';

export default function useUserData() {
  const { userData } = useSelector((s) => s.userDataSlice);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const setUserData = (newUserData) => {
    dispatch(setUserDataAction(newUserData));
  };

  const fetchUserData = (token) => {
    API.getToken('/profile', token)
    .then(d => {
      if (d?.status === 401) {
        navigate(ROUTES.AUTH);
      }

      if (d?.status === 200) {
        setUserData(d.data);
      } else {
        setUserData(null);
      }
    });
  };

  const isAdmin = userData?.role === "admin";

  return { userData, isAdmin, setUserData, fetchUserData };
}
